<template>
    <div>
      <div style="display: flex;flex-direction: column;align-items: center;padding: 15px 15px 0px 15px;background: #f4f4f4;margin-bottom: 30px;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <a href="/">{{$t("index.homepage")}}</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item,index) in breadcrumb.split(';')" :key="index">
            <span>{{(item || "").split(',')[$store.state.i18nVal]}}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
        <h1 style="color: #5d84b3;border-bottom: 4px solid;padding-bottom: 10px;margin-bottom: 0;">{{(breadcrumbtitle || "").split(',')[$store.state.i18nVal]}}</h1>
      </div>
      <div class="container">
            <div class="hidden-md-and-down"  style="display: flex;flex-wrap: wrap;justify-content: space-between;">
              <div v-for="(item,index) in dataList" :key="item.id" style="width: 48%;margin-bottom: 10px;cursor: pointer;">
                  <el-card shadow="hover" @click.native="openClick(item)" :body-style="{ padding: '0px' ,display: 'flex'}">
                      <img :src="$url+item.cmsArticleDto.coverImg" style="object-fit: cover;width: 40%;height: 9vw;">
                      <div style="padding: 0 20px;font-weight: 700;">
                          <p>{{(item.cmsArticleDto.titleZhTwEn || "").split(',')[$store.state.i18nVal]}}</p>
                          <span style="color: #5d84b3;font-weight: 100;">{{(item.cmsArticleDto.subTitleZhTwEn || "").split(',')[$store.state.i18nVal]}}</span>
                          <div class="hl_event_button" style="margin-top: 10px;">
                            <el-button @click.native="openClick(item)" plain>{{$t("index.viewdetails")}}</el-button>
                          </div>
                      </div>
                  </el-card>
              </div>
            </div>
            <div class="hidden-md-and-up">
              <el-row>
                  <el-col class="hl_event_mdup" :xs="24" :sm="24" :md="24" v-for="(item,index) in dataList" :key="index">
                      <el-card :body-style="{ padding: '0px' }" @click.native="openClick(item)"> 
                       <img :src="$url+item.cmsArticleDto.coverImg" class="image">
                      <div class="hl_event_mdup_span">
                          <div style="font-weight: 700;font-size: 1.0625em;margin-bottom: .75rem;">{{(item.cmsArticleDto.titleZhTwEn || "").split(',')[$store.state.i18nVal]}}</div>
                          <div style="font-size: .8125em;margin-bottom: .75rem;">  {{(item.cmsArticleDto.subTitleZhTwEn || "").split(',')[$store.state.i18nVal]}}</div>
                          <div>
                              <div class="hl_event_button">
                                  <el-button @click="openClick(item)">{{$t("index.viewdetails")}}</el-button>
                                  <el-button icon="el-icon-share" circle></el-button>
                              </div>
                          </div>
                      </div>
                      </el-card>
                  </el-col>
              </el-row>
          </div>
      </div>
    </div>
  </template>
<script>
import { getIndex } from '@/api/index'
export default {
  watch: {
        $route(to, from) {
            // 判断跳转的路径是否你要监听的路径，我这里为 '/search'
            if (to.name == "list") {
                // 通过新的参数值获取新的数据
                this.getIndex()
            }
        }
    },
    data(){
      return{
        dataList:[],
        breadcrumb:[],
        breadcrumbtitle:'',
      }
    },
    created(){
      this.getIndex()
    },
    methods: {
      getIndex(){
        this.$http({
            method: 'get',
            baseURL: this.$baseURL,
            url: '/api/Index/getlist',
            params:{
              code:JSON.parse(decodeURI(this.$route.params.id)).code,
              levels:JSON.parse(decodeURI(this.$route.params.id)).levels,
              id:JSON.parse(decodeURI(this.$route.params.id)).id
            },
            withCredentials: true,
         }).then(response=>{
            this.dataList = response.data.children
            this.breadcrumb = response.data.pNames
            this.breadcrumbtitle = response.data.name
         })
      },
      openClick(data)
    {
        // 音乐家样式  music
       if(data.code==="guestconductor" || data.code==="listmusicians" || data.code==="musicdirector" || data.code==="musicianinresidence")
       {
            let param = {
                pcode:data.code,
            }
            param = encodeURI(JSON.stringify(param))
            param = encodeURI(param)
            switch (data.code) 
          {
            case 'guestconductor':
            this.$router.push({path:`/musician/guestconductor/${param}`})
            break;
            case 'listmusicians':
            this.$router.push({path:`/musician/listmusicians/${param}`})
              break;
            case 'musicdirector':
            this.$router.push({path:`/musician/musicdirector/${param}`})
            break;
            case 'musicianinresidence':
            this.$router.push({path:`/musician/musicianinresidence/${param}`})
            break;
          }
       }else if(data.children && data.children.length>0){//多子项页面样式  list
            let param = {
                code:data.code,
                levels:data.levels,
                id:data.id
            }
            param = encodeURI(JSON.stringify(param))
            param = encodeURI(param)
            this.$router.push({path:`/list/${param}`});
       } else{
            let param = {id:data.id}
            param = encodeURI(JSON.stringify(param))
            param = encodeURI(param)
            this.$router.push({path:`/container/${param}`});
       }
    },
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
     .hl_event_button{
        .el-button{
            border: 1px  solid white !important;
            color: #FFF;
            background-color: #5d84b3;
            border-color: #5d84b3;
            font-size: .875rem;
            border-radius: 0;
        }
        .el-button:hover{
            color: #FFF;
            background-color: #4081d1;
            border-color: #4081d1;
        }
        .el-button:focus {
            color: #FFF;
            background-color:  #5d84b3;
            border-color:  #5d84b3;
        }
    }
    .hl_event_mdup_span{
        padding: 14px;
      .hl_event_button{
            .el-button{
                border: 1px  solid white !important;
                color: #FFF;
                background-color: #5d84b3;
                border-color: #5d84b3;
                font-size: .875rem;
                border-radius: 0;
            }
            .el-button:hover{
                color: #FFF;
                background-color: #4081d1;
                border-color: #4081d1;
            }
            .el-button:focus {
                color: #FFF;
                background-color:  #5d84b3;
                border-color:  #5d84b3;
            }
        }
    }
</style>